import * as React from 'react';

import {autobind} from '@shopify/javascript-utilities/decorators';

interface Props {
  className?: string;
  href: string;
  mode?: 'current' | 'first' | 'last' | 'next' | 'prev' | null;
  onClick?: (page: number) => any;
  pageNumber: number;
}

export default class Page extends React.PureComponent<Props, {}> {
  @autobind
  handleClick(event) {
    const {onClick, pageNumber} = this.props;

    if (onClick) {
      onClick(pageNumber);
      event.preventDefault();
    }
  }

  getText() {
    const {mode, pageNumber} = this.props;

    switch (mode) {
      case 'first': {
        return '« First';
      }
      case 'prev': {
        return '‹ Prev';
      }
      case 'next': {
        return 'Next ›';
      }
      case 'last': {
        return 'Last »';
      }
      default: {
        return pageNumber;
      }
    }
  }

  render() {
    const {className, mode, href} = this.props;

    const children = this.getText();

    if (mode === 'current') {
      return <span className={className}>{children}</span>;
    } else {
      return (
        <span className={className}>
          <a href={href} onClick={this.handleClick}>
            {children}
          </a>
        </span>
      );
    }
  }
}
